'use client'

import Hotjar from '@hotjar/browser'
import { useEffect } from 'react'

export default function HotjarInit() {
  const hjid = process.env.NEXT_PUBLIC_HOTJAR_ID
  const hjsv = Number(process.env.NEXT_PUBLIC_HOTJAR_SV ?? 6)

  useEffect(() => {
    if (!hjid) return
    Hotjar.init(Number(hjid), hjsv)
  }, [hjid, hjsv])

  return null
}
